export const bpmTranslations = {
  en: {
    taskList: {
      myTasks: "My Tasks",
      myHistory: "My Completed Tasks",
      taskName: "Task Name",
      processInstance: "Process Instance",
      createdAt: "Created At",
      dueDate: "Due Date",
      startTime: "Start Time",
      endTime: "End Time",
      duration: "Duration",
      actions: "Actions",
      approve: "Approve",
      refresh: "Refresh",
      loading: "Loading...",
      noTasks: "No pending tasks",
      noHistory: "No completed tasks",
    },
    approveTask: {
      approve: "Approve",
      reject: "Reject",
      cancel: "Cancel",
      notFound: "Task not found",
      loading: "Loading...",
      submitting: "Submitting...",
    },
  },
  "zh-CN": {
    taskList: {
      myTasks: "我的待办",
      myHistory: "我的已办",
      taskName: "任务名称",
      processInstance: "流程实例",
      createdAt: "创建时间",
      dueDate: "截止时间",
      startTime: "开始时间",
      endTime: "结束时间",
      duration: "耗时",
      actions: "操作",
      approve: "审批",
      refresh: "刷新",
      loading: "加载中...",
      noTasks: "暂无待办任务",
      noHistory: "暂无已办任务",
    },
    approveTask: {
      approve: "同意",
      reject: "拒绝",
      cancel: "取消",
      notFound: "任务不存在",
      loading: "加载中...",
      submitting: "提交中...",
    },
  },
};

/**
 * Add BPM translations to i18next instance
 */
export function addBpmTranslations(i18n: {
  addResourceBundle: (
    lng: string,
    ns: string,
    resources: Record<string, unknown>,
    deep?: boolean,
    overwrite?: boolean
  ) => void;
}) {
  Object.entries(bpmTranslations).forEach(([lng, resources]) => {
    i18n.addResourceBundle(lng, "bpm", resources, true, true);
  });
}
